require '$.slider'
